import React from 'react';

import Placeholder from 'components/consumer/Placeholder';
import RatingAndReviewsWrapper from './RatingAndReviewsWrapper';

const RatingAndReviewsPlaceholder = () => (
  <RatingAndReviewsWrapper>
    <Placeholder
      type="rect"
      loading
      style={{ height: '17px', width: '83px' }}
    />
  </RatingAndReviewsWrapper>
);

export default RatingAndReviewsPlaceholder;
